// Create a sort function, sorting a list by a field.
export const ByField =
  <T,>(field: keyof T) =>
  (a: T, b: T): number =>
    (a[field] ?? 0) < (b[field] ?? 0) ? -1 : 1
